module.exports = __webpack_public_path__ + "static/media/the_hidden_plastic_in_our_food_system_mobile.87f5bb68.jpg";